import { render, staticRenderFns } from "./MapWrapper.vue?vue&type=template&id=45a8ef61&scoped=true&"
import script from "./MapWrapper.vue?vue&type=script&lang=js&"
export * from "./MapWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MapWrapper.vue?vue&type=style&index=0&id=45a8ef61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a8ef61",
  null
  
)

export default component.exports